import {ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren} from '@angular/core';
import {Title} from "@angular/platform-browser";
import {Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
  TwoStepVerificationService
} from "../../../pages/content/services/twoStepVerification/two-step-verification.service";
import {AuthService} from "../_services/auth.service";
import {BehaviorSubject} from "rxjs";
import {AuthHTTPService} from "../_services/auth-http";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-verification-code',
  templateUrl: './verification-code.component.html',
  styleUrls: ['./verification-code.component.scss']
})
export class VerificationCodeComponent implements OnInit ,OnDestroy {
  @ViewChildren('codeInput') codeInputs!: QueryList<ElementRef>;

  twoFactorForm: FormGroup;
  isLoading = false;
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private twoStepVerificationService: TwoStepVerificationService,
    private router: Router,
    private titleService: Title,
    private authService: AuthService,
    private authHTTPService: AuthHTTPService,
    public toastrService: ToastrService,
    private cdRef: ChangeDetectorRef,

  ) {
    this.titleService.setTitle("Two-Factor Authentication (2FA)");

    this.twoFactorForm = this.fb.group({
      code_0: ['', [Validators.required, Validators.pattern('[0-9]')]],
      code_1: ['', [Validators.required, Validators.pattern('[0-9]')]],
      code_2: ['', [Validators.required, Validators.pattern('[0-9]')]],
      code_3: ['', [Validators.required, Validators.pattern('[0-9]')]],
      code_4: ['', [Validators.required, Validators.pattern('[0-9]')]],
      code_5: ['', [Validators.required, Validators.pattern('[0-9]')]]
    });
    if (!this.authService.tempUserValue){
      this.router.navigate(['']);
    }
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.codeInputs.first.nativeElement.focus();
    }, 0);
  }

  onInputChange(event: any, index: number) {
    const input = event.target;
    const value = input.value;

    // Auto-tab to next input when a digit is entered
    if (value.length === 1 && index < 5) {
      this.codeInputs.toArray()[index + 1].nativeElement.focus();
    }

    // Allow backspace to move to previous field
    if (event.key === 'Backspace' && index > 0 && !value) {
      this.codeInputs.toArray()[index - 1].nativeElement.focus();
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const clipboardData = event.clipboardData?.getData('text').trim();

    if (clipboardData && /^\d{6}$/.test(clipboardData)) {
      const digits = clipboardData.split('');
      this.twoFactorForm.patchValue({
        code_0: digits[0],
        code_1: digits[1],
        code_2: digits[2],
        code_3: digits[3],
        code_4: digits[4],
        code_5: digits[5]
      });
      this.codeInputs.last.nativeElement.focus();
    }
  }

  onSubmit() {
    if (this.twoFactorForm.invalid) {
      return;
    }

    this.isLoading = true;

    const code = Object.values(this.twoFactorForm.value).join('');

    this.twoStepVerificationService.validateOTOPCode(code).subscribe({
      next: (response) => {

        this.isLoading = false;
        this.authService.setAuthFromLocalStorage(response, response.auth);
        this.authHTTPService.getUserByToken(response.auth.token).subscribe({
          next: (res:any) => {
            this.authService.currentUserSubject.next(res);
            this.authService.currentUserTokenSubject = new BehaviorSubject<string>(response.auth.token);
            this.authService.tempUserSubject.next(null);
            const redirectUrl = localStorage.getItem('redirect_url');
            if (redirectUrl && redirectUrl !== 'undefined' && redirectUrl.trim()) {
              const cleanUrl = redirectUrl.replace(/^"|"$/g, '').trim();
              if (cleanUrl && cleanUrl !== 'undefined') {
                localStorage.removeItem('redirect_url');
                this.router.navigate([cleanUrl]);
              } else {
                this.router.navigate(['/']);
              }
            } else {
              this.router.navigate(['/']);
            }

          },
          error: (err) => {
            this.isLoading = false;
          }
        });
        this.cdRef.detectChanges();

      },
      error: (err) => {
        this.isLoading = false;
        this.toastrService.error('Invalid verification code. Please try again.');
        this.resetForm();
        this.cdRef.detectChanges();

      }
    });
  }

  resetForm() {
    this.twoFactorForm.reset();
    setTimeout(() => {
      this.codeInputs.first.nativeElement.focus();
    }, 0);
  }
  ngOnDestroy() {
    this.titleService.setTitle("THYNK Scrubber");

  }


}
